import { ref } from 'vue'

export const TRANSCRIBE_ENDS_BLOB_PART = new Uint8Array([0])
export const TRANSCRIBE_CONTINUES_BLOB_PART = new Uint8Array([1])
export const TRANSCRIBE_EOF_MESSAGE = '<EOF>'

export const useSpeechToText = () => {
  const transcribeAudioWs = ref<WebSocket>()

  const audioAvailableHandler = (audio: Blob): Promise<void> => {
    const stream = new Blob([audio, TRANSCRIBE_CONTINUES_BLOB_PART], { type: audio.type })
    transcribeAudioWs.value?.send(stream)
    return Promise.resolve()
  }

  const startConversion = (availableHandler?: (text: string) => void) => {
    // Close previous socket
    transcribeAudioWs.value?.close()

    transcribeAudioWs.value = new WebSocket(import.meta.env.VITE_MIA_TRANSCRIBE_AUDIO_SOCKET)
    transcribeAudioWs.value.onmessage = async function (event) {
      const text = event.data as string
      if (text === TRANSCRIBE_EOF_MESSAGE) {
        transcribeAudioWs.value?.close()
        transcribeAudioWs.value = undefined
        return
      }

      if (availableHandler) {
        availableHandler(text)
      }
    }
  }

  const stopConversion = () => {
    const stream = new Blob([TRANSCRIBE_ENDS_BLOB_PART])
    transcribeAudioWs.value?.send(stream)
  }

  return { audioAvailableHandler, startConversion, stopConversion }
}
